var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJo = function SvgJo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 840 420"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007a3d",
    d: "M0 0h840v420H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h840v280H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h840v140H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M0 0v420l420-210z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m129.787 180 6.508 16.485 16.947-5.19-8.83 15.367 14.623 10.014-17.52 2.676 1.289 17.677L129.787 225l-13.016 12.03 1.289-17.678-17.52-2.676 14.623-10.014-8.83-15.367 16.946 5.19z"
  })));
};
export default SvgJo;